// Personal data is memory-only. Only explicitly harmless presentation preferences persist.
const BrowserState = (() => {
    const memory = new Map();
    // sicaf_last_activity: a timestamp shared by open tabs for the classroom idle sign-out (no personal data).
    const preferences = new Set(['ecpv_dark_mode','messages_sidebar_width','messages_list_width','pre_matricula_columns','sicaf_last_activity','leads_page_size']);
    let disk, temporary;
    try {disk = window.localStorage;} catch { /* Some browsers deny even the storage getter. */ }
    try {temporary = window.sessionStorage;} catch { /* Memory-only operation is still available. */ }
    // One-way cleanup of this app's old cache; do not clear unrelated origin storage.
    for (const storage of [disk, temporary]) {
        try {
            for (let i=storage.length-1;i>=0;i--) {
                const key=storage.key(i);
                if (key?.startsWith('ecpv_') && key !== 'ecpv_login_reveal' && !preferences.has(key)) storage.removeItem(key);
            }
        } catch { /* Storage may be disabled. No personal cache is restored. */ }
    }
    return {
        getItem(key) { try {return preferences.has(key)?disk.getItem(key):memory.get(key) ?? null;} catch {return null;} },
        setItem(key,value) { if(preferences.has(key)){try{disk.setItem(key,String(value));}catch{}} else memory.set(key,String(value)); },
        removeItem(key) {memory.delete(key);try{disk.removeItem(key);}catch{}},
        clear() {memory.clear();}
    };
})();
window.BrowserState = BrowserState;
